// extracted by mini-css-extract-plugin
export default {"paleSky":"#667085","input":"styles_input__6SmJT","icon":"styles_icon__Ca7So","inputContainer":"styles_inputContainer__vWehp"};